import { Injectable } from '@angular/core';
import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import { SocketService } from './socket.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ClearService {

	constructor(
		private router: Router,
		private socketService: SocketService,
		private transactionLogService: TransactionLogService,
		private userService: UserService
	) { }

	logout(): void {
		// Save current state info to localSession
		sessionStorage.setItem('prevState', JSON.stringify({
			// name: this.stateService.current.name,
			path: this.router.url
		}));
		// Clear selectedCustomer
		// this.userService.selectedCustomerId.next(null);
		this.userService.selectedCustomer.next(null);
		// Remove token
		this.userService.removeToken();
		this.userService.removeA3iApiKey();
		// Disconnect socket
		this.socketService.disconnectSocket();
		this.transactionLogService.socketProcesses.next([]);
		// this.stateService.go('login');
		this.router.navigate(['/auth/login'], {
			queryParamsHandling: 'merge' // To keep socket sidekick params
		});
	}
}
